import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'
import { dedupeStrings, firstActiveRun, progressFromRun } from './backendRunProgressUtils'

export function appendPendingRunMessage(messages, runs) {
  const run = firstActiveRun(runs)
  if (!run) return messages
  if (messages.some((message) => isPendingAssistant(message))) return messages
  const lastUser = [...messages].reverse().find((message) => message.role === 'user')
  const progress = progressFromRun(run)
  return [...messages, pendingRunMessage(run, lastUser, progress)]
}

export function mergePendingRunProgress(messages, runs) {
  const run = firstActiveRun(runs)
  if (!run) return messages
  const progress = progressFromRun(run)
  if (!progress.summary && progress.details.length === 0) return messages
  return messages.map((message) => (isPendingAssistant(message) ? mergeProgress(message, progress) : message))
}

function pendingRunMessage(run, lastUser, progress) {
  return {
    id: `pending-${run?.id || Date.now()}`,
    role: 'assistant', text: ASSISTANT_PENDING_TEXT,
    createdAt: Date.now(), thinkingStartedAt: Date.now(),
    exchangeId: lastUser?.exchangeId || lastUser?.id,
    versionIndex: lastUser?.versionIndex || 0,
    assistantVersionIndex: 0,
    thoughtSummary: progress.summary || 'Working',
    thoughtDetails: progress.details,
    streamProgressEventIds: progress.eventIds,
    autoExpandPreamble: progress.details.length > 0,
    agentName: 'assistant', agentBrand: 'SIA',
  }
}

function mergeProgress(message, progress) {
  return {
    ...message,
    thoughtSummary: progress.summary || message.thoughtSummary || 'Working',
    thoughtDetails: dedupeStrings([...(message.thoughtDetails || []), ...progress.details]).slice(-40),
    streamProgressEventIds: dedupeStrings([...(message.streamProgressEventIds || []), ...progress.eventIds]).slice(-40),
    autoExpandPreamble: true,
    agentName: message.agentName || 'assistant',
    agentBrand: message.agentBrand || 'SIA',
    createdAt: Date.now(),
  }
}

function isPendingAssistant(message) { return message.role === 'assistant' && message.text === ASSISTANT_PENDING_TEXT }
